import React, { FC, memo, useCallback, useMemo } from 'react';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { DebtCollectionFilter, UsersListFilterKeys } from '../../model/types';
import { DefaultOptionType } from 'antd/es/select';
import { Select } from 'shared/ui/Select';

interface DebtCollectionSelectProps {
  value: string;
  onChange: (value: string, label: string) => void;
  onClear: (filterKey: string) => void;
}

export const DebtCollectionSelect: FC<DebtCollectionSelectProps> = memo((props) => {
  const { value, onChange, onClear } = props;

  const { t } = useAppTranslation(['contracts', 'user']);

  const debtCollectionOptions = useMemo<Array<{ label: string; value: DebtCollectionFilter }>>(() => {
    return [
      { label: t('In progress', { ns: 'user' }), value: DebtCollectionFilter.IN_PROGRESS },
      { label: t('Not started', { ns: 'user' }), value: DebtCollectionFilter.NOT_STARTED },
    ];
  }, [t]);

  const clearFilter = useCallback(() => {
    onClear(UsersListFilterKeys.isInDebtCollection);
  }, [onClear]);

  const handleChange = useCallback(
    (value: string, option?: DefaultOptionType | DefaultOptionType[]): void => {
      if (!Array.isArray(option) && typeof option?.label === 'string') {
        onChange(value, option.label);
      }
    },
    [onChange],
  );

  return (
    <Select
      containerClassName="flex-1"
      className="w-full"
      label={t('Debt collection', { ns: 'user' })}
      placeholder={t('All')}
      bordered
      allowClear
      options={debtCollectionOptions}
      value={value}
      onChange={handleChange}
      onClear={clearFilter}
    />
  );
});
